













import { Component, Vue } from 'vue-property-decorator';
import layout from '@/layouts/basic-layout.vue';

@Component({
    components: {
        layout,
    },
})
export default class AccessDenied extends Vue {}
